import { render, staticRenderFns } from "./GlobalErrorModal.vue?vue&type=template&id=cd0653cc"
import script from "./GlobalErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalErrorModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports